import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import SafetySection from './components/SafetySection';
import NewsletterSection from './components/NewsletterSection';
import { useJsonLd } from '@/hooks/useJsonLd';
import { SITE_URL } from '@/constants/site';

const homeJsonLd = [
  {
    '@type': 'Organization',
    name: 'LitBuy Spreadsheets',
    url: SITE_URL + '/',
    description: 'Your trusted resource hub for LitBuy spreadsheet guides, product categories, and safe shopping tips.',
  },
  {
    '@type': 'WebSite',
    name: 'LitBuy Spreadsheets',
    url: SITE_URL + '/',
    description: 'Your trusted resource hub for LitBuy spreadsheet guides, product categories, and safe shopping tips.',
    potentialAction: {
      '@type': 'SearchAction',
      target: SITE_URL + '/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What exactly is a LitBuy spreadsheet?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'A LitBuy spreadsheet is an organized document that compiles product listings, seller information, pricing data, quality ratings, and direct purchase links from the LitBuy platform. It acts as your personal shopping assistant, centralizing all relevant product information into a single, searchable document across categories like shoes, hoodies, t-shirts, jackets, and more.',
        },
      },
      {
        '@type': 'Question',
        name: 'Are LitBuy spreadsheets free to use?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Many LitBuy spreadsheets offer free basic access with essential category listings and seller information. Premium versions with advanced features like real-time updates, exclusive product finds, and detailed quality check photos are typically available for a small fee.',
        },
      },
      {
        '@type': 'Question',
        name: 'How often are the spreadsheets updated?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Update frequency varies by spreadsheet creator. The best LitBuy spreadsheets are updated at least weekly, with some receiving daily updates during peak shopping seasons. Always check the last update date before relying on a spreadsheet for your shopping decisions.',
        },
      },
      {
        '@type': 'Question',
        name: 'Can I trust the seller ratings in the spreadsheets?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'While spreadsheet seller ratings are generally reliable, you should always do your own verification. Check seller store ratings on LitBuy directly, read recent buyer reviews, and join community discussions to get the most complete picture of seller reliability.',
        },
      },
      {
        '@type': 'Question',
        name: 'What product categories are available in LitBuy spreadsheets?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'LitBuy spreadsheets cover categories including Shoes, Hoodies and Sweaters, T-Shirts, Jackets, Pants and Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and more. Each category contains organized product listings with direct links, pricing, and seller information.',
        },
      },
      {
        '@type': 'Question',
        name: 'How do LitBuy spreadsheets compare to manual searching?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'LitBuy spreadsheets dramatically outperform manual searching in almost every aspect. They provide instant side-by-side price comparisons, pre-vetted sellers with community ratings, and one-click access to product pages. While manual searching can take hours per session, spreadsheets let you find what you need in minutes.',
        },
      },
    ],
  },
];

export default function Home() {
  useJsonLd(homeJsonLd);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <FeaturedArticles />
        <Testimonials />
        <CTASection />
        <FAQSection />
        <SafetySection />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
}